// hooks/useWebView.ts
import { useState, useEffect } from 'react';

const useWebView = (): number => {
  const [isWebView, setIsWebView] = useState<number>(0);

  useEffect(() => {
    const checkWebView = (): number => {
      const userAgent = navigator.userAgent.toLowerCase();
      // Common WebView patterns
      const webViewPatterns = [
        /wv/,                          // Android WebView
        /; wv\)/,                      // Android WebView
        // /mobile safari\/[.0-9]*/,      // iOS WebView
        // /;fbav/,                       // Facebook WebView
        // /line\/[.0-9]*/,               // LINE WebView
        // /instagram [.0-9]*/,            // Instagram WebView
        // /snapchat\/[.0-9]*/,           // Snapchat WebView
        // /twitterandroid\/[.0-9]*/,      // Twitter WebView
        // /tiktok\/[.0-9]*/              // TikTok WebView
      ];

      // iOS WebView specific check
      const isIOS = /iphone|ipad|ipod/.test(userAgent);
      if (isIOS && !userAgent.includes('safari/')) {
        return 1;
      }

      // Android WebView specific check
      else if (/android/.test(userAgent) && /; wv\)/.test(userAgent)) {
        return 1;
      }
      else if (webViewPatterns.some(pattern => pattern.test(userAgent))){
        return 1;
      }
      else{
        return 2;
      }

      // Check for other WebView patterns
    };

    setIsWebView(checkWebView());
  }, []);

  return isWebView;
};

export default useWebView;